import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import allImgPaths from "assets/images";
import { Modal } from "components/common/modal/Modal";
import { HeaderModal } from "components/common/modal/Header";
import { Body } from "components/common/modal/Body";

const BudgetRollOver = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const MaximizeModal = () => {
    return (
      <Modal
        className={"modal-wrapper max-w-[690px]"}
        isShow={openMaximizeModal}
      >
        <img
          className='cursor-pointer absolute top-3 right-3'
          id='modal-toggle'
          src={allImgPaths.closeIcon}
          onClick={() => setOpenMaximizeModal(false)}
          alt='close icon'
        />
        <Body title='header' isShowBody={true} className=''>
          <div className='bg-[#fff] rounded-xl'>
            {/* Budget Rollover Heading */}
            <div className='pb-5 border-b border-[#EAECF0]'>
              <div className='flex items-center gap-x-4 pt-6 px-6'>
			  	<img src={allImgPaths.budgetRollover} alt="" />
				<div className="">
					<h4 className='text-lg text-[#101828] font-interSemiBold pb-0.5'>
					Budget Rollover
					</h4>
					<p className='text-sm font-interMedium text-[#98A2B3]'>
						Description here
					</p>
				</div>
              </div>
            </div>

            <div className='px-5 py-5'>
			<div className="border border-[#EAECF0] rounded-xl px-6 py-6">

              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgVenue} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Venue
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    1,509
                  </span>
                  <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                    +12%
                  </span>
                </div>
              </div>

              {/* Food & Beverage */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgFood} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Food & Beverage
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    1460
                  </span>
                  <span className='bg-[#FEF3F2] px-2 py-1 text-[#EB3D4D] text-xs font-interSemiBold rounded-md'>
                    -5%
                  </span>
                </div>
              </div>

              {/* Entertainment */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgEntertaintment} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Entertainment
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    1,229
                  </span>
                  <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                    0%
                  </span>
                </div>
              </div>

              {/* Gift Hampers */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgGifts} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Gift Hampers
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    982
                  </span>
                  <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                    +19%
                  </span>
                </div>
              </div>

              {/* Entertainment */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgEntertaintment2} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Entertainment
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    -
                  </span>
                  <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                    0%
                  </span>
                </div>
              </div>

              {/* AV equipment */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgAv} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    AV equipment
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    -
                  </span>
                  <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                    0%
                  </span>
                </div>
              </div>

              {/* Guest Speaker */}
              <div className='flex items-center justify-between mb-4 last:mb-0'>
                <div className='flex items-center gap-x-3'>
                  <img src={allImgPaths.budgGuest} alt='' />
                  <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    Guest Speakers
                  </h5>
                </div>
                <div className='flex gap-x-2 items-center'>
                  <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                    -
                  </span>
                  <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                    0%
                  </span>
                </div>
              </div>
			</div>
            </div>
          </div>
        </Body>
      </Modal>
    );
  };
  return (
    <>
      <div className='bg-[#fff] rounded-xl border border-[#EAECF0] px-6 pt-6 pb-4 w-[360px]'>
        {/* Budget Rollover Heading */}
        <div className='pb-5'>
          <div className='flex items-center justify-between'>
            <h4 className='text-lg text-[#101828] font-interSemiBold pb-0.5'>
              Budget Rollover
            </h4>
            <div
              className='p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]'
              onClick={() => setShowOptions(!showOptions)}
            >
              <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt='three dots' />
              <InsightCardsOptions
                isShow={showOptions}
                openMaximizeModal={() => setOpenMaximizeModal(true)}
                chartName = ''
                downloadChartName = 'budgetRollOver'
              />
            </div>
          </div>
          <p className='text-sm font-interMedium text-[#98A2B3]'>
            Description here
          </p>
        </div>

        <div className=''>
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgVenue} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Venue
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                1,509
              </span>
              <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                +12%
              </span>
            </div>
          </div>

          {/* Food & Beverage */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgFood} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Food & Beverage
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                1460
              </span>
              <span className='bg-[#FEF3F2] px-2 py-1 text-[#EB3D4D] text-xs font-interSemiBold rounded-md'>
                -5%
              </span>
            </div>
          </div>

          {/* Entertainment */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgEntertaintment} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Entertainment
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                1,229
              </span>
              <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                0%
              </span>
            </div>
          </div>

          {/* Gift Hampers */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgGifts} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Gift Hampers
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                982
              </span>
              <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                +19%
              </span>
            </div>
          </div>

          {/* Entertainment */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgEntertaintment2} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Entertainment
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                -
              </span>
              <span className='bg-[#ECFDF3] px-2 py-1 text-[#1A9882] text-xs font-interSemiBold rounded-md'>
                0%
              </span>
            </div>
          </div>

          {/* AV equipment */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgAv} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                AV equipment
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                -
              </span>
              <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                0%
              </span>
            </div>
          </div>

          {/* Guest Speaker */}
          <div className='flex items-center justify-between mb-4 last:mb-0'>
            <div className='flex items-center gap-x-3'>
              <img src={allImgPaths.budgGuest} alt='' />
              <h5 className='font-interSemiBold text-sm text-[#1D1F2C]'>
                Guest Speakers
              </h5>
            </div>
            <div className='flex gap-x-2 items-center'>
              <span className='font-interSemiBold text-sm text-[#1D1F2C]'>
                -
              </span>
              <span className='bg-[#F0F1F3] px-2 py-1 text-[#4A4C56] text-xs font-interSemiBold rounded-md'>
                0%
              </span>
            </div>
          </div>
        </div>
      </div>
      <MaximizeModal />
    </>
  );
};

export default BudgetRollOver;
